import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'lib/jquery'
import RoomPageBase from './room-page-base'
import HoudiniSchedule from 'frontend/pages/rooms/houdini-schedule'
import moment from 'lib/moment-timezone-custom'
import Glide, { Controls, Autoplay, Swipe, Breakpoints, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import Reviews from 'frontend/pages/rooms/reviews'

export default class HoudiniPage extends RoomPageBase {
  static imagesSlider () {
    new Glide('.images .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          focusAt: 'center',
          autoplay: 6000,
          perView: 2,
          breakpoints: { 480: { perView: 1 } }
        }
      )
    ).mount({ Swipe, Controls, Autoplay, Breakpoints })
  }

  static handleDOMReady () {
    super.handleDOMReady()
    this.onEnter('.images .slider', () => this.imagesSlider())
    const roomId = $(document.body).data('room-id')
    const openedFrom = $(document.body).data('opened-from')
    const root = document.getElementById('room_schedule_react')
    if (root && openedFrom && roomId) {
      ReactDOM.render(
        <HoudiniSchedule
          roomId={roomId}
          openedFrom={moment(openedFrom)}
          prebookingCodeOnly={$(document.body).data('prebooking-code-only') !== undefined}
        />,
        root
      )
    } else {
      if (!root) {
        console.warn('No RoomSchedule mount element found')
      } else if (!openedFrom) {
        console.warn('No openedFrom, schedule should not render')
      } else if (!roomId) {
        console.warn('No roomId')
      }
    }
  }

  static handleStylesApplied () {
    Reviews.init()
  }
}

HoudiniPage.init()
